import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getLateComingList(data, token) {
    return axios.post(APP_SETTINGS.API_PATH.LATECOMING.getLateComingList, data, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    })
}